var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "company" },
    [
      !_vm.selectedList
        ? _c("div", { staticClass: "no company-card" }, [
            _c("span", [_vm._v(_vm._s(_vm.$tc("PleaseSelectList", 1)))])
          ])
        : _vm._e(),
      _vm._v(" "),
      !!_vm.selectedList
        ? _c(
            "div",
            { staticClass: "company-info-container" },
            [
              _c("object-main-info", {
                key: _vm.updateObjectMainInfoKey,
                attrs: {
                  fields: _vm.fields,
                  identifier: _vm.list ? _vm.list.name : "",
                  "identifier-label": _vm.$tc("Label", 1),
                  "editing-data": _vm.editingData,
                  "show-edit-button":
                    _vm.actionToExecute !== "createCustomList" &&
                    _vm.tableActiveTab !== 0,
                  "card-label": _vm.cardLabel,
                  height: _vm.height,
                  "submit-button-label": _vm.submitButtonLabel,
                  "required-fields-filled": _vm.requiredFieldsAreFilled
                },
                on: {
                  "toggle-edit": _vm.toggleEdit,
                  "update-object": _vm.updateList
                }
              }),
              _vm._v(" "),
              !_vm.showPermissions
                ? _c("lists-specific-info", {
                    attrs: {
                      editingData: _vm.editingData,
                      list: _vm.list ? _vm.list : [],
                      "required-fields-filled": _vm.requiredFieldsAreFilled,
                      entries: _vm.entriesData ? _vm.entriesData : [],
                      tableActiveTab: _vm.tableActiveTab,
                      workspaces: _vm.list ? _vm.list.workspaces : [],
                      hasChanges: _vm.detectedChanges,
                      deleteActionButtonDisable:
                        _vm.tableActiveTab === 1 ? false : true,
                      actionToExecute: _vm.actionToExecute,
                      mainCardHeight: "60%"
                    },
                    on: {
                      "cancel-edit": function($event) {
                        _vm.discardChangesDialogIsOpen = true
                      },
                      "save-material": function($event) {
                        _vm.saveChangesDialogIsOpen = true
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("loading-spinner", {
        staticStyle: { position: "absolute" },
        attrs: {
          active: _vm.loading,
          "is-full-page": false,
          color: "var(--app-primary-base)"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      }),
      _vm._v(" "),
      _c("dialog-choice", {
        attrs: {
          isOpen: _vm.saveChangesDialogIsOpen,
          title: _vm.$t("SaveChanges"),
          content: _vm.$t("SaveChangesContent"),
          mainActionLabel: _vm.$t("Confirm"),
          secondaryActionLabel: _vm.$t("Cancel"),
          icon: "mdi-content-save",
          iconColor: "var(--app-primary-base)"
        },
        on: {
          mainAction: _vm.saveObject,
          secondaryAction: function($event) {
            _vm.saveChangesDialogIsOpen = false
          }
        }
      }),
      _vm._v(" "),
      _c("dialog-choice", {
        attrs: {
          isOpen: _vm.discardChangesDialogIsOpen,
          title: _vm.$t("DiscardChanges"),
          content: _vm.$t("ClusterCreationConfirmation"),
          mainActionLabel: _vm.$t("Confirm"),
          secondaryActionLabel: _vm.$t("Cancel"),
          icon: "mdi-delete",
          iconColor: "var(--app-primary-base)"
        },
        on: {
          mainAction: _vm.cancelEdit,
          secondaryAction: function($event) {
            _vm.discardChangesDialogIsOpen = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-000cad70", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-000cad70","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/SystemManagement/Lists/Lists.vue
// module id = null
// module chunks = 